import { render } from "./CaiDatEditModal.vue?vue&type=template&id=742e8808&ts=true"
import script from "./CaiDatEditModal.vue?vue&type=script&lang=ts"
export * from "./CaiDatEditModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__